import { defineStyleConfig } from "@chakra-ui/react"

const Link = defineStyleConfig({
  baseStyle: {
    color: 'brand.purple'
  },
})

export default Link
